const initialState = {
  pending: false,
  fulfilled: null,
  rejected: null,
};

export const API = 'API';

export default function actionReducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: { type: any; payload: any }
) {
  switch (action.type) {
    case `${API}_PENDING`:
      return {
        ...state,
        pending: true,
        fulfilled: null,
        rejected: null,
      };
    case `${API}_FULFILLED`:
      return {
        ...state,
        pending: false,
        fulfilled: action.payload,
        rejected: null,
      };
    case `${API}_REJECTED`:
      return {
        ...state,
        pending: false,
        fulfilled: null,
        rejected: action.payload,
      };

    default:
      return state;
  }
}
